import { ThunkAction, ThunkDispatch } from 'redux-thunk';

import { ICompanyMemberRequest } from '../models';
import { CompanyMemberService } from '../../services';

import { TAppError } from '@/store/types/base.state';
import { IProfileState, TProfileAction, ProfileActionTypes } from '@/store/types/profile.types';

import { IUser } from '@/features/user/store/user.model';

export const getUserChildren = ({
  parentUserId,
  ...searchParams
}: ICompanyMemberRequest): ThunkAction<Promise<void>, IProfileState, {}, TProfileAction> => {
  const request = (): TProfileAction => ({
    type: ProfileActionTypes.GET_CHILDREN_USER,
    userId: parentUserId,
  });
  const fail = (error: TAppError): TProfileAction => ({
    type: ProfileActionTypes.GET_CHILDREN_USER_FAIL,
    userId: parentUserId,
    error,
    documentation: 'https://docs.treezor.com/guide/users/parent-children.html#key-attributes',
  });
  const success = (parentUserId: number, children: IUser[], maxItems?: number): TProfileAction => ({
    type: ProfileActionTypes.GET_CHILDREN_USER_SUCCESS,
    shouldSkipToaster: true,
    parentUserId,
    children,
    maxItems,
  });

  return async (dispatch: ThunkDispatch<{}, {}, TProfileAction>): Promise<void> => {
    dispatch(request());
    try {
      const children = await CompanyMemberService.searchChildrenUsers({ parentUserId, ...searchParams });
      const maxItems = Object.keys(searchParams)?.length === 0 ? children?.[0]?.totalRows : undefined;
      dispatch(success(parentUserId, children, maxItems));
    } catch (error) {
      dispatch(fail(error));
    }
  };
};
